<template>
  <div>
    <base-card>
      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4" v-if="isLoading">
        <div v-for="i in 8" :key="i">
          <base-skeleton-loader class="tw-h-2 tw-w-10 tw-mt-1" />
          <base-skeleton-loader class="tw-h-3 tw-w-24 tw-mt-2 tw-mb-2" />
        </div>
      </div>
      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4" v-else>
        <div class="tw-grid tw-gap-4">
          <base-field title="Started On" :value="formattedStartDate" />
          <base-field title="Billing Cycle" :value="formattedBillingCycle" />
          <base-field title="Renews On" :value="formattedRenewDate" />
          <base-field v-if="useCreditsSetting === true" title="Credits at Signup">
            <div v-for="ic in plan.itemCategories" :key="ic.userBusinessItemCategoryId">
              {{ ic.quantity + ic.initialQuantity }} {{ ic.name }}{{ ic.quantity + ic.initialQuantity === 1 ? "" : "s" }}
            </div>
          </base-field>
        </div>
        <div class="tw-grid tw-gap-4">
          <base-field title="Price">
            <MoneyFormat :value="plan.priceCents" :locale="locale" :currency-code="plan.currency" subunits-value />
            <span v-if="plan.isTaxable">+ tax</span>
          </base-field>
          <base-field title="Next Billing Date" :value="formattedNextInvoiceDate" />
          <base-field title="Agreement Period" :value="formattedTerm" />
          <base-field v-if="useCreditsSetting === true" title="Credits per Cycle">
            <div v-for="ic in plan.itemCategories" :key="ic.userBusinessItemCategoryId">{{ ic.quantity }} {{ ic.name }}{{ ic.quantity === 1 ? "" : "s" }}</div>
          </base-field>
        </div>
      </div>
      <div class="tw-flex tw-justify-center tw-mt-5">
        <base-skeleton-loader v-if="isLoading" class="tw-h-2 tw-w-24 tw-mt-2 tw-mb-1.5" />
        <base-button type="text" @click="$refs.agreementModal.show()" v-else>View Plan Agreement</base-button>
      </div>
    </base-card>
    <base-modal ref="agreementModal" size="2xl">
      <base-card shadow>
        <UserBusinessPlanAgreement
          :userId="userId"
          :userBusinessPlanId="userBusinessPlanId"
          :planName="plan.planName"
          :priceCents="plan.priceCents"
          :currency="plan.currency"
          :businessName="plan.businessName"
          :termLength="plan.termLength"
          :termInterval="plan.termInterval"
          :cycleFrequency="plan.cycleFrequency"
          :cycleInterval="plan.cycleInterval"
          :startDate="plan.startDate"
          :serviceFeeCents="plan.serviceFeeCents"
        />
        <div class="sm:tw-flex sm:tw-justify-end tw-mt-4">
          <base-button type="secondary" @click="$refs.agreementModal.hide()" class="tw-w-full sm:tw-w-auto">Close</base-button>
        </div>
      </base-card>
    </base-modal>
  </div>
</template>

<script>
import UserBusinessPlanAgreement from "@/views/user/components/UserBusinessPlanAgreement";
import MoneyFormat from "vue-money-format";
import moment from "moment";

export default {
  components: {
    UserBusinessPlanAgreement,
    MoneyFormat,
  },
  props: {
    userId: String,
    userBusinessPlanId: String,
    useCreditsSetting: Boolean,
  },
  data() {
    return {
      isLoading: false,
      plan: {},
    };
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    formattedStartDate() {
      return moment
        .utc(this.plan.startDate, "YYYY-MM-DD-HH-mm-ss")
        .local()
        .format("MMM Do, YYYY");
    },
    formattedRenewDate() {
      var renewDate = moment.utc(this.plan.startDate).local();

      var interval = "M";
      switch (this.plan.termInterval) {
        case "day":
          interval = "d";
          break;
        case "week":
          interval = "w";
          break;
        case "month":
          interval = "M";
          break;
        case "year":
          interval = "y";
          break;
      }

      return renewDate.add(this.plan.termLength, interval).format("MMM Do, YYYY");
    },
    formattedNextInvoiceDate() {
      return this.plan.nextInvoiceDate
        ? moment
            .utc(this.plan.nextInvoiceDate, "YYYY-MM-DD-HH-mm-ss")
            .local()
            .format("MMM Do, YYYY h:mm A")
        : "Not Available";
    },
    formattedBillingCycle() {
      return this.plan.cycleFrequency > 1 ? `Every ${this.plan.cycleFrequency} ${this.plan.cycleInterval}s` : `Every ${this.plan.cycleFrequency} ${this.plan.cycleInterval}`;
    },
    formattedTerm() {
      return this.plan.termInterval === "year" ? `${12 * this.plan.termLength} months` : `${this.plan.termLength} ${this.plan.termInterval}`;
    },
  },
  created() {
    this.EventBus.$on("member_update", this.getPlanDetails);
    this.getPlanDetails();
  },
  beforeDestroy() {
    this.EventBus.$off("member_update", this.getPlanDetails);
  },
  methods: {
    async getPlanDetails() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/users/${this.userId}/plans/${this.userBusinessPlanId}`);
        this.plan = response.data;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
